<template>
  <div class="leftres">
    <div>
      <div style="width: 980px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);  background-color: #FFFFFF;">
        <Salesmanleveltable></Salesmanleveltable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>
<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import Salesmanleveltable from './components/salesmanleveltable.vue'
export default {
  components: {
    Commondropdownlist,
    Salesmanleveltable,
    Dialog,
    CommonBtngroup
  },
  data() {
    return {
      username: '',
      name: '',
      dialogVisibles: false,
      formdata: [
        {
          inputdata: '',
          title: '产品线',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'select',
          width: '170px',
          btx: true,
          // lablewith: '90px',
          options: [{
            key: "1",
            value: "哈哈哈",
          },
          {
            key: "2",
            value: "嘿嘿",
          }]
        },
        {
          inputdata: '',
          title: '经销商/医院',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '160px',
          lablewith: '90px'
        }, 
          {
          inputdata: "",
          title: "创建日期",
          fontSize: "14px",
          color: "#333333",
          placeholder: "请输入",
          types: "",
          inputtype: "date",
          width: "140px",
        //   lablewith: '95px'
        },{
          inputdata: '',
          title: '年度',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'select',
          width: '170px',
          btx: true,
          // lablewith: '90px',
          options: [{
            key: "1",
            value: "哈哈哈",
          },
          {
            key: "2",
            value: "嘿嘿",
          }]
        },
      ]
    }
  },
  mounted() {

  },
  methods: {
    reset() {

      this.dialogVisibles = true
    },
    cancel() {
      //console.log('name')
      this.dialogVisibles = false
    },
    dialogOK() {
      //console.log('name2')
      this.dialogVisibles = false
    }
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 50px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
}
</style>